class MaisonLocalizationForm {
  constructor(form) {
    this.form = form;

    this.countryMapEl = this.form.querySelector('[data-localization-country-languages]');

    this.countryLanguageMap = {};

    if (this.countryMapEl) {
      try {
        this.countryLanguageMap = JSON.parse(this.countryMapEl.textContent || '{}');
      } catch (e) {
        console.warn('MaisonLocalizationForm: invalid country/language JSON', e);
      }
    }

    this.countryWrapper = this.form.querySelector('.maison-country-select');
    this.countryTrigger = this.form.querySelector('[data-country-trigger]');
    this.countryTriggerLabel = this.form.querySelector('[data-country-trigger-label]');
    this.countrySearch = this.form.querySelector('[data-country-search]');
    this.countryList = this.form.querySelector('[data-country-list]');
    this.countryEmpty = this.form.querySelector('[data-country-empty]');
    this.countryInput = this.form.querySelector('[data-country-input]');

    this.languageWrapper = this.form.querySelector('.maison-language-select');
    this.languageTrigger = this.form.querySelector('[data-language-trigger]');
    this.languageTriggerLabel = this.form.querySelector('[data-language-trigger-label]');
    this.languageList = this.form.querySelector('[data-language-list]');
    this.languageInput = this.form.querySelector('[data-language-input]');

    if (
      !this.countryWrapper ||
      !this.countryTrigger ||
      !this.countryList ||
      !this.countryInput ||
      !this.languageWrapper ||
      !this.languageTrigger ||
      !this.languageList ||
      !this.languageInput
    ) {
      console.warn('MaisonLocalizationForm: missing required markup', this.form);
      return;
    }

    this.init();
  }

  init() {
    this.countryTrigger.addEventListener('click', () => {
      const isOpen = this.countryWrapper.dataset.open === 'true';

      if (isOpen) {
        this.closeCountryDropdown();
      } else {
        this.closeLanguageDropdown();
        this.openCountryDropdown();
      }
    });

    this.languageTrigger.addEventListener('click', () => {
      const isOpen = this.languageWrapper.dataset.open === 'true';

      if (isOpen) {
        this.closeLanguageDropdown();
      } else {
        this.closeCountryDropdown();
        this.openLanguageDropdown();
      }
    });

    this.countryList.addEventListener('click', event => {
      const option = event.target.closest('[data-country-option]');
      if (!option) return;

      this.selectCountry(option.dataset.value, option.dataset.label);
    });

    this.languageList.addEventListener('click', event => {
      const option = event.target.closest('[data-language-option]');
      if (!option) return;

      this.selectLanguage(option.dataset.value, option.dataset.label);
    });

    if (this.countrySearch) {
      this.countrySearch.addEventListener('input', () => {
        this.filterCountries();
      });
    }

    document.addEventListener('click', event => {
      if (!this.form.contains(event.target)) {
        this.closeCountryDropdown();
        this.closeLanguageDropdown();
      }
    });
    this.form.addEventListener('submit', () => this.rememberChoice());
  }

  openCountryDropdown() {
    this.countryWrapper.dataset.open = 'true';
    this.countryTrigger.setAttribute('aria-expanded', 'true');

    requestAnimationFrame(() => {
      if (this.countrySearch) this.countrySearch.focus();
    });
  }

  rememberChoice() {
    const country = this.countryInput.value;
    const language = this.languageInput.value;
    if (!country || !language) return;

    const value = encodeURIComponent(JSON.stringify({ c: country, l: language }));
    document.cookie =
      'maison-localization=' + value +
      ';path=/;max-age=' + 60 * 60 * 24 * 365 + ';SameSite=Lax';
  }

  closeCountryDropdown() {
    this.countryWrapper.dataset.open = 'false';
    this.countryTrigger.setAttribute('aria-expanded', 'false');
  }

  openLanguageDropdown() {
    this.languageWrapper.dataset.open = 'true';
    this.languageTrigger.setAttribute('aria-expanded', 'true');
  }

  closeLanguageDropdown() {
    this.languageWrapper.dataset.open = 'false';
    this.languageTrigger.setAttribute('aria-expanded', 'false');
  }

  selectCountry(code, label) {
    this.countryInput.value = code;
    this.countryTriggerLabel.textContent = label;

    this.countryList
      .querySelectorAll('[data-country-option]')
      .forEach(option => {
        option.classList.toggle('is-active', option.dataset.value === code);
      });

    if (this.countrySearch) {
      this.countrySearch.value = '';
      this.filterCountries();
    }

    this.updateLanguages(code);
    this.closeCountryDropdown();
  }

  selectLanguage(code, label) {
    this.languageInput.value = code;
    this.languageTriggerLabel.textContent = label;

    this.languageList
      .querySelectorAll('[data-language-option]')
      .forEach(option => {
        option.classList.toggle('is-active', option.dataset.value === code);
      });

    this.closeLanguageDropdown();
  }

  updateLanguages(countryCode) {
    const available =
      this.countryLanguageMap[countryCode] ||
      this.countryLanguageMap[String(countryCode).toUpperCase()] ||
      [];

    if (!available.length) {
      console.warn('MaisonLocalizationForm: no languages found for', countryCode);
      return;
    }

    const current = this.languageInput.value;

    this.languageList.innerHTML = '';

    available.forEach(lang => {
      const button = document.createElement('button');

      button.type = 'button';
      button.className = 'maison-select__option';
      button.setAttribute('data-language-option', '');
      button.setAttribute('data-value', lang.code);
      button.setAttribute('data-label', lang.label);

      button.innerHTML = `<span>${lang.label}</span>`;

      this.languageList.appendChild(button);
    });

    const nextLanguage =
      available.find(lang => lang.code === current) ||
      available[0];

    this.selectLanguage(nextLanguage.code, nextLanguage.label);
  }

  filterCountries() {
    const value = this.countrySearch.value.trim().toLowerCase();

    let visible = 0;

    this.countryList
      .querySelectorAll('[data-country-option]')
      .forEach(option => {

        const label =
          option.dataset.label.toLowerCase();

        const match =
          label.includes(value);

        option.style.display =
          match ? '' : 'none';

        if (match) visible++;
      });

      if (this.countryEmpty) {

        this.countryEmpty.style.display =
          visible === 0 ? 'block' : 'none';
      }
    }
  }

function initMaisonLocalizationForms() {
  document
    .querySelectorAll('.maison-localization-form')
    .forEach(form => {
      if (form.dataset.initialized === 'true') return;

      form.dataset.initialized = 'true';

      new MaisonLocalizationForm(form);
    });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMaisonLocalizationForms);
} else {
  initMaisonLocalizationForms();
}

document.addEventListener('shopify:section:load', initMaisonLocalizationForms);